<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">{{ $t("nav.home") }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Contracts' }">{{
            $t("nav.contracts")
          }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ $t("nav.contract") + (contract ? contract.cont_id : "") }}
        </li>
        <li class="li_right">
          <router-link :to="{ name: 'Contracts' }" class="retour">
            <font-awesome-icon :icon="['fas', 'reply']" />
            {{ $t("lnk.return.tolist") }}
          </router-link>
        </li>
      </ol>
    </nav>
    <b-container v-if="contract != null">
      <b-card
        border-variant="secondary"
        header="Informations"
        header-border-variant="secondary"
      >
        <b-card-text class="right-badge">
          <b-badge v-if="isClos()" variant="danger">
            <font-awesome-icon :icon="['fas', 'times']" />
            {{ $t("label.status_ended") }}
          </b-badge>
          <b-badge v-else variant="success">
            <font-awesome-icon :icon="['fas', 'check']" />
            {{ $t("label.status_actif") }}
          </b-badge>
        </b-card-text>
        <b-card-text class="text-left">
          <b-row>
            <b-col>{{ $t("label.contrat_id") }}</b-col>
            <b-col>{{ contract ? contract.cont_id : "" }}</b-col>
          </b-row>
          <b-row>
            <b-col>{{ $t("label.start_date") }}</b-col>
            <b-col>{{ formatDate(contract.cont_date_start) }}</b-col>
          </b-row>
          <b-row
            @mouseover="showPencil = true"
            @mouseleave="showPencil = false"
          >
            <b-col>{{ $t("label.end_date") }}</b-col>
            <b-col>
              <b-row v-if="!showEditDate" @click="showEditDate = true">
                <b-col v-if="contract.cont_date_end !== null">
                  {{ formatDate(contract.cont_date_end) }}
                </b-col>
                <b-col v-else
                  ><em>{{ $t("label.undefine") }}</em>
                </b-col>
                <b-col>
                  <span v-if="showPencil">
                    <font-awesome-icon :icon="['fas', 'edit']"
                  /></span>
                </b-col>
              </b-row>
              <b-row v-else>
                <b-col>
                  <b-form-input
                    id="input-date-end"
                    v-model="formDateEnd"
                    type="date"
                  />
                </b-col>
                <b-col>
                  <b-button
                    v-b-tooltip.hover
                    :title="$t('btn.tip.edit_date')"
                    pill
                    variant="outline-success"
                    @click="bindEndContract"
                  >
                    <font-awesome-icon :icon="['fas', 'check-square']" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    :title="$t('btn.tip.del_date')"
                    pill
                    variant="outline-danger"
                    @click="bindNoEndContract"
                  >
                    <font-awesome-icon :icon="['fas', 'trash']" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    :title="$t('btn.tip.cancel')"
                    pill
                    @click="cancelEndContract"
                    variant="outline-secondary"
                  >
                    <font-awesome-icon :icon="['fas', 'times']" />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>{{ $t("label.offer") }}</b-col>
            <b-col>{{ contract.cont_off_name }}</b-col>
          </b-row>
          <b-row>
            <b-col>{{ $t("label.formation_amount") }}</b-col>
            <b-col v-if="contract.cont_formation_amount != null"
              >{{ contract.cont_formation_amount }} €</b-col
            >
            <b-col v-else
              ><em>{{ $t("label.undefine") }}</em></b-col
            >
          </b-row>
          <b-row>
            <b-col>{{ $t("label.subscription_amount") }}</b-col>
            <b-col v-if="contract.cont_subscription_amount != null"
              >{{ contract.cont_subscription_amount }} €</b-col
            >
            <b-col v-else
              ><em>{{ $t("label.undefine") }}</em></b-col
            >
          </b-row>
          <b-row>
            <b-col>{{ $t("label.material_amount") }}</b-col>
            <b-col v-if="contract.cont_material_amount != null"
              >{{ contract.cont_material_amount }} €</b-col
            >
            <b-col v-else
              ><em>{{ $t("label.undefine") }}</em></b-col
            >
          </b-row>
          <br />
          <b-row>
            <b-col>{{ $t("label.comment") }}</b-col>
            <b-col v-if="contract.cont_misc != null">{{ getComment() }}</b-col>
            <b-col v-else
              ><em>{{ $t("label.undefine") }}</em></b-col
            >
          </b-row>
          <br />
          <b-row>
            <b-col>{{ $t("label.linked_establishment") }}</b-col>
            <b-col />
          </b-row>
          <b-row>
            <b-col v-if="contract.establishments == null"
              ><em>{{ $t("label.no_esta_linked") }}</em></b-col
            >
            <b-col v-else>
              <b-list-group>
                <b-list-group-item
                  v-for="establishment in contract.establishments"
                  :key="establishment.esta_id"
                  class="d-flex justify-content-between align-items-center"
                >
                  <router-link
                    :to="{
                      name: 'EstablishmentDetails',
                      params: { id: establishment.esta_id },
                    }"
                  >
                    {{ establishment.esta_name }}
                  </router-link>
                  <b-button
                    pill
                    variant="outline-danger"
                    @click="removeEstablishment(establishment.esta_id)"
                    style="height: 4.5rem; width: 4.5rem"
                  >
                    <font-awesome-icon :icon="['fas', 'trash']" />
                    <p>{{ $t("label.unlink") }}</p>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card-text>
        <b-card-text class="text-center mt-3">
          <b-container>
            <b-row align-h="center">
              <b-col cols="6" align-self="center">
                <b-button
                  v-b-toggle.link-establishment
                  variant="outline-primary"
                  >{{ $t("btn.link_esta") }}</b-button
                >
                <b-collapse id="link-establishment" class="mt-2">
                  <b-card>
                    <b-container>
                      <b-button
                        v-b-modal.modal-import-establishment-list
                        variant="outline-success"
                        >{{ $t("btn.import_xls_estas") }}</b-button
                      >
                      <b-modal
                        id="modal-import-establishment-list"
                        :title="$t('modal.title.import_estas')"
                        scrollable
                        hide-footer
                      >
                        <form-import-list
                          :id="contract.cont_id"
                          :button-disabled="buttonDisabled"
                          @sendForm="receiveFormXlsx"
                        />
                      </b-modal>
                    </b-container>
                    <b-container>ou</b-container>
                    <b-form-group
                      id="input-group-establishments"
                      :label="$t('label.lnk_exist_esta')"
                      label-for="input-establishments"
                    >
                      <b-form-select
                        id="input-relativeto"
                        v-model="newEstablishment"
                        :options="estasWithNoContrat"
                        @change="selectChange"
                      />
                    </b-form-group>
                  </b-card>
                </b-collapse>
              </b-col>
            </b-row>
          </b-container>
        </b-card-text>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import FormEstablishment from "../components/forms/FormEstablishment.vue";
import FormImportList from "../components/forms/FormImportList.vue";
import {
  getEstablishmentsWithNoContract,
  importEstablishements,
} from "../services/establishment";
import {
  getContract,
  removeEstablishment,
  addEstablishment,
  setDateEndContract,
} from "../services/contract";
import {
  formatStringDate,
  formatStringDateBDD,
  dateBeforeNow,
} from "../misc/utils";

export default {
  name: "ContractDetails",
  components: {
    FormEstablishment,
    FormImportList,
  },
  data() {
    return {
      estasWithNoContrat: [],
      newEstablishment: null,
      buttonDisabled: false,
      showPencil: false,
      showEditDate: false,
      contract: null,
      formDateEnd: null,
    };
  },
  mounted() {
    this.updateStore();
  },
  methods: {
    formatDate(d) {
      return formatStringDate(d);
    },
    isClos() {
      return dateBeforeNow(this.contract.cont_date_end);
    },
    async getListorphans() {
      this.estasWithNoContrat = await getEstablishmentsWithNoContract();
    },
    async updateStore() {
      this.$bvModal.hide("modal-import-establishment-list");

      this.getListorphans();
      this.contract = await getContract(this.$route.params.id);
      this.formDateEnd = formatStringDateBDD(this.contract.cont_date_end);
      this.buttonDisabled = false;
    },
    async selectChange() {
      if (!this.contract.establishments) {
        this.contract.establishments = [];
      }
      const c = this.estasWithNoContrat.find(
        (c) => c.value === this.newEstablishment
      );
      if (c) {
        this.contract.establishments.push({
          esta_id: this.newEstablishment,
          esta_name: c.text,
        });
        await addEstablishment(this.contract.cont_id, this.newEstablishment)
          .then(() => {
            this.getListorphans();
          })
          .catch((error) => {
            console.error(error);
            this.showToast(
              "danger",
              this.$t("msg.text.error_cont_add_esta"),
              this.$t("msg.title.contrat")
            );
          });
      }
    },
    async receiveFormXlsx(formList) {
      this.buttonDisabled = true;
      await importEstablishements(this.contract.cont_id, formList)
        .then(() => this.updateStore())
        .catch((error) =>
          this.showToast("danger", error, this.$t("msg.title.contrat"))
        );
    },
    async removeEstablishment(estaId) {
      const i = this.contract.establishments.findIndex(
        (c) => c.esta_id === estaId
      );
      if (i > -1 ) {
        console.log('delete')
        this.contract.establishments.splice(i, 1);
        await removeEstablishment(this.contract.cont_id, estaId)
          .then(() => {
            this.getListorphans();
          })
          .catch((error) => {
            console.error(error);
            this.showToast(
              "danger",
              this.$t("msg.text.error_cont_del_esta"),
              this.$t("msg.title.contrat")
            );
          });
      }
    },
    async setDate() {
      await setDateEndContract(
        this.contract.cont_id,
        this.contract.cont_date_end
      ).catch((error) => {
        console.error(error);
        this.showToast(
          "danger",
          this.$t("msg.text.error_cont_set_dateend"),
          this.$t("msg.title.contrat")
        );
      });
    },
    getComment() {
      return JSON.parse(this.contract.cont_misc).comment;
    },
    bindEndContract() {
      this.contract.cont_date_end = this.formDateEnd;
      this.setDate();
      this.showEditDate = false;
    },
    bindNoEndContract() {
      this.formDateEnd = null;
      this.contract.cont_date_end = null;
      this.setDate();
      this.showEditDate = false;
    },
    cancelEndContract() {
      this.showEditDate = false;
    },
  },
};
</script>

<style scoped>
.right-badge {
  text-align: right;
}
.retour {
  color: black;
}
.li_right {
  margin-left: auto;
}
</style>
